/* eslint-disable max-lines */
/* eslint-disable sort-keys */
import bandeiras from './assets/imagens/bandeiras'
import KitIneditos from './assets/imagens/kit-ineditos.jpg'
import KitCuradoria from './assets/imagens/kit-curadoria.jpg'
import { URLS_APP } from './config'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'

export const ROUTE = {
  'ASSINATURA_PRESENTE': 'ROUTE_ASSINATURA_PRESENTE',
  'BLOG': 'ROUTE_BLOG',
  'BOOKSTER': 'ROUTE_BOOKSTER',
  'CURADORIA': 'ROUTE_CURADORIA',
  'CURADORIA_ENTREGA': 'ROUTE_CURADORIA_ENTREGA',
  'CURADORIA_PAGAMENTO': 'ROUTE_CURADORIA_PAGAMENTO',
  'CURADORIA_PLANO': 'ROUTE_CURADORIA_PLANO',
  'GANHE_DESCONTOS': 'ROUTE_GANHE_DESCONTOS',
  'HOME': 'ROUTE_HOME',
  'INEDITOS': 'ROUTE_INEDITOS',
  'INEDITOS_ENTREGA': 'ROUTE_INEDITOS_ENTREGA',
  'INEDITOS_PAGAMENTO': 'ROUTE_INEDITOS_PAGAMENTO',
  'INEDITOS_PLANO': 'ROUTE_INEDITOS_PLANO',
  'LOGIN': 'ROUTE_LOGIN',
  'LOGOUT': 'ROUTE_LOGOUT',
  'LOJA': 'ROUTE_LOJA',
  'MEUS_KITS': 'ROUTE_MEUS_KITS',
  'PERFIL': 'ROUTE_PERFIL'
}

export const URLS = {
  'ASSINATURA_PRESENTE': 'presente',
  'ASSINATURA_PRESENTE_RESGATE': 'presente/resgate',
  'BLOG': 'http://taglivros.com/blog',
  'BOOKSTER': 'bookster',
  'CANAL_ATENDIMENTO': 'https://duvidas.taglivros.com/pt-BR/collections/357565-entrega-e-rastreamento',
  'CANCELAR_ASSINATURA_INICIAL': 'cancelar-assinatura',
  'CANCELAR_ASSINATURA_AVISO_MULTA': 'cancelar-assinatura/aviso-multa',
  'CANCELAR_ASSINATURA_SUSPENSAO': 'cancelar-assinatura/suspensao',
  'CANCELAR_ASSINATURA_MOTIVOS_SUSPENSAO': 'motivos-suspensao',
  'CANCELAR_ASSINATURA_SUSPENSAO_CONCLUSAO': 'conclusao',
  'CANCELAR_ASSINATURA_MOTIVOS_CANCELAMENTO': 'cancelar-assinatura/motivos-cancelamento',
  'CANCELAR_ASSINATURA_CONCLUSAO': 'conclusao',
  'CURADORIA': 'curadoria',
  'CURADORIA_ENTREGA': 'curadoria/entrega',
  'CURADORIA_PAGAMENTO': 'curadoria/pagamento',
  'CURADORIA_PLANO': 'curadoria/plano',
  'CONTINUAR_ASSINATURA_PLANO': 'continuar-assinatura/selecionar-plano',
  'CONTINUAR_ASSINATURA_ENTREGA': 'continuar-assinatura/selecionar-entrega',
  'CONTINUAR_ASSINATURA_PAGAMENTO': 'continuar-assinatura/selecionar-pagamento',
  'CONTINUAR_ASSINATURA_CONCLUSAO': 'continuar-assinatura/conclusao',
  'DUVIDAS': 'https://duvidas.taglivros.com/central-ajuda/',
  'ENTREGA': 'entrega',
  'ESQUECI_MINHA_SENHA': 'esqueci-minha-senha',
  'GANHE_DESCONTOS': 'ganhe-descontos',
  'HOME': '/',
  'INEDITOS': 'ineditos',
  'INEDITOS_ENTREGA': 'ineditos/entrega',
  'INEDITOS_PAGAMENTO': 'ineditos/pagamento',
  'INEDITOS_PLANO': 'ineditos/plano',
  'LOJA': 'https://livraria.taglivros.com/',
  'LOGIN': 'login',
  'LOGOUT': 'logout',
  'MEUS_KITS': 'meus-kits',
  'PAGAMENTO': 'pagamento',
  'PERFIL': 'perfil',
  'PLANO': 'plano',
  'REDEFINIR_SENHA': 'redefinir-senha',
  'REATIVAR_ASSINATURA_PLANO': 'reativar-assinatura/selecionar-plano',
  'REATIVAR_ASSINATURA_ENTREGA': 'reativar-assinatura/selecionar-entrega',
  'REATIVAR_ASSINATURA_PAGAMENTO': 'reativar-assinatura/selecionar-pagamento',
  'REATIVAR_ASSINATURA_CONCLUSAO': 'reativar-assinatura/conclusao',
  'RENOVAR_PLANO': 'renovar-plano',
  'RENOVAR_PLANO_ENTREGA': 'renovar-plano/selecionar-entrega',
  'RENOVAR_PLANO_PAGAMENTO': 'renovar-plano/selecionar-pagamento',
  'RENOVAR_PLANO_CONCLUSAO': 'renovar-plano/conclusao',
  'SEGUNDA_ASSINATURA_PLANO': 'segunda-assinatura/selecionar-plano',
  'SEGUNDA_ASSINATURA_ENTREGA': 'segunda-assinatura/selecionar-entrega',
  'SEGUNDA_ASSINATURA_PAGAMENTO': 'segunda-assinatura/selecionar-pagamento',
  'SEGUNDA_ASSINATURA_CONCLUSAO': 'segunda-assinatura/conclusao',
  'SUSPENSAO_ASSINATURA': 'plano/cancelar-assinatura/suspensao',
  'TRILHAS': 'https://clube.taglivros.com/tag-trilhas/',
  'UPGRADE_CONCLUSAO': 'upgrade/conclusao',
  'UPGRADE_ENTREGA': 'upgrade/selecionar-entrega',
  'UPGRADE_PAGAMENTO': 'upgrade/selecionar-pagamento',
  'SETUP_ASSINATURA': 'setup/setup-assinatura',
  'SETUP_ASSINATURA_ESCOLHA_CLUBE': 'setup/setup-assinatura-clube',
  'SITE': 'https://site.taglivros.com/'
}

export const VALID_STATES = [
  'UF', 'AC', 'AL', 'AM', 'AP', 'BA', 'CE',
  'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB',
  'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC',
  'SE', 'SP', 'TO'
]

export const FLUXOS_PAGAMENTO = {
  'REATIVACAO': 'reativação de plano',
  'RENOVACAO': 'renovação de plano',
  'SEGUNDA_ASSINATURA': 'assinatura',
  'UPGRADE': 'upgrade de plano'
}

export const ETAPAS_FLUXO_PAGAMENTO = {
  'ROUTE_BRINDES': 'BRINDES',
  'ROUTE_CONCLUSAO': 'CONCLUSAO',
  'ROUTE_ENTREGA': 'ENTREGA',
  'ROUTE_PAGAMENTO': 'PAGAMENTO',
  'ROUTE_PLANO': 'PLANO'
}

export const MODALIDADE_CURADORIA = {
  'cor': StyleGuide.cores.azul,
  'fotos': {
    'kit': KitCuradoria
  },
  'id': 1,
  'informacaoKit': [
    'Livro em edição exclusiva (capa dura)',
    'Revista sobre autor e obra',
    'Box colecionável',
    'Mimo literário',
    'Marcador de página',
    'Playlist personalizada'
  ],
  'slug': 'curadoria',
  'titulo': 'TAG Curadoria',
  'visualizacao': 'Curadoria'
}

export const MODALIDADE_INEDITOS = {
  'cor': StyleGuide.cores.laranja,
  'fotos': {
    'kit': KitIneditos
  },
  'id': 2,
  'informacaoKit': [
    'Livro em edição exclusiva(brochura)',
    'Revista sobre autor e obra',
    'Box colecionável',
    'Mimo literário',
    'Marcador de página',
    'Playlist personalizada'
  ],
  'slug': 'ineditos',
  'titulo': 'TAG Inéditos',
  'visualizacao': 'Inéditos'
}

export const MODALIDADE_BOOKSTER = {
  'cor': '#262A5F',
  'fotos': {
    'kit': null
  },
  'id': 4,
  'informacaoKit': [],
  'slug': 'bookster',
  'titulo': 'Bookster Pelo Mundo',
  'visualizacao': 'Bookster'
}

export const INFORMACAO_MODALIDADES = [ MODALIDADE_CURADORIA, MODALIDADE_INEDITOS, MODALIDADE_BOOKSTER ]

export const CATEGORIA_BOOKSTER = {
  'id': 4,
  'nome': 'BOOKSTER',
  'slug': 'bookster'
}

export const CATEGORIAS_CLUBE_NORMAL = [ 'CURADORIA', 'INEDITOS' ]

export const URLS_BOLETO = [
  'boleto-futuro',
  'segunda-via-boleto',
  'trocar-forma-pagamento'
]

export const METODO_PAGAMENTO_CARTAO = {
  'id': 1,
  'inicial': 'C',
  'slug': 'cartao-credito',
  'slugBackend': 'CARTAO_CREDITO',
  'visualizacao': 'Cartão de Crédito'
}

export const METODO_PAGAMENTO_BOLETO = {
  'id': 2,
  'idBackend': 0,
  'inicial': 'B',
  'slug': 'boleto',
  'slugBackend': 'BOLETO',
  'visualizacao': 'Boleto bancário'
}

export const METODO_PAGAMENTO_PIX = {
  'id': 3,
  'idBackend': 0,
  'inicial': 'P',
  'slug': 'pix',
  'slugBackend': 'PIX',
  'visualizacao': 'PIX',
  'desconto': 5,
}

export const PLANO_MENSAL = {
  'parcelas': 1,
  'slug': 'mensal',
  'visualizacao': 'Mensal'
}

export const PLANO_TRIMESTRAL = {
  'parcelas': 3,
  'slug': 'trimestral',
  'visualizacao': 'Trimestral'
}

export const PLANO_SEMESTRAL = {
  'parcelas': 6,
  'slug': 'semestral',
  'visualizacao': 'Semestral'
}

export const PLANO_ANUAL = {
  'parcelas': 12,
  'slug': 'anual',
  'visualizacao': 'Anual'
}

export const PLANOS = [ PLANO_ANUAL, PLANO_MENSAL, PLANO_SEMESTRAL, PLANO_TRIMESTRAL ]

export const PLANOS_VALIDOS_PARA_UPGRADE = [ PLANO_MENSAL, PLANO_TRIMESTRAL ]

export const REQUIRED_MESSAGE = 'Campo Obrigatório'

export const INVALID_CEP = 'CEP Inválido'

export const BANDEIRAS_IMAGES = {
  'amex': bandeiras.amex,
  'elo': bandeiras.elo,
  'hipercard': bandeiras.hipercard,
  'mastercard': bandeiras.mastercard,
  'visa': bandeiras.visa
}

export const PAGAMENTO_CARTAO = 'Cartão de Crédito'

export const PAGAMENTO_BOLETO = 'Boleto bancário'

export const PAGAMENTO_PIX = 'PIX'

export const STATUS_CANCELADO = 'Cancelado'

export const STATUS_AGUARDANDO_CANCELAMENTO = 'Aguardando Cancelamento'

export const STATUS_SOLICITOU_CANCELAMENTO = 'Solicitou Cancelamento'

export const STATUS_VENDA_ESPERA = 'espera'

export const METODOS_PAGAMENTO_BOLETO = 'boleto bancário'

export const METODOS_PAGAMENTO_CARTAO_CREDITO = 'cartao de crédito'

export const METODOS_PAGAMENTO_PIX = 'pix'

export const AVISO_PIX_MENSAL = 'A opção de pagamento mensal não é válida para pix. Escolha uma das opções e complete a compra:'

export const AVISO_ASSINATURA_REATIVADA = 'Assinatura reativada com sucesso!'

export const METODOS_PAGAMENTO = {
  [ METODO_PAGAMENTO_CARTAO.slug ]: METODO_PAGAMENTO_CARTAO,
  [ METODO_PAGAMENTO_PIX.slug ]: METODO_PAGAMENTO_PIX,
}

export const VER_MAIS = 'ver mais'

export const BOTAO_FINALIZAR = 'Finalizar'

export const EVENTOS_GA = {
  'UPGRADE': {
    'ACOES': {
      'BRINDES': 'Passo Brindes em Upgrade',
      'ENTREGA': 'Passo Entrega em Upgrade',
      'INIT': 'Entrou em Upgrade',
      'PAGAMENTO': 'Passo Pagamento em Upgrade',
      'CONCLUSAO': 'Concluiu Upgrade'
    },
    'ACOES_VOLTAR': {
      'BRINDES': 'Voltou para passo Brindes em Upgrade',
      'PAGAMENTO': 'Voltou para passo Pagamento em Upgrade',
      'ENTREGA': 'Voltou para passo Entrega em Upgrade'
    },
    'FLUXO': 'UPGRADE'
  },
  'SEGUNDA_ASSINATURA': {
    'ACOES': {
      'BRINDES': 'Passo Brindes em Segunda Assinatura',
      'CONCLUSAO': 'Concluiu Segunda Assinatura',
      'ENTREGA': 'Passo Entrega em Segunda Assinatura',
      'INIT': 'Entrou em Segunda Assinatura',
      'PAGAMENTO': 'Passo Pagamento em Segunda Assinatura',
      'PLANO': 'Passo Escolha de Plano em Segunda Assinatura'
    },
    'ACOES_VOLTAR': {
      'BRINDES': 'Voltou para passo Brindes em Segunda Assinatura',
      'ENTREGA': 'Voltou para passo Entrega em Segunda Assinatura',
      'PAGAMENTO': 'Voltou para passo Pagamento em Segunda Assinatura',
      'PLANO': 'Voltou para passo Escolha de Plano em Segunda Assinatura'
    },
    'FLUXO': 'SEGUNDA_ASSINATURA'
  },
  'RENOVACAO': {
    'ACOES': {
      'BRINDES': 'Passo Brindes em Renovação',
      'CONCLUSAO': 'Concluiu Renovação',
      'ENTREGA': 'Passo Entrega em Renovação',
      'INIT': 'Entrou em Renovação',
      'PAGAMENTO': 'Passo Pagamento em Renovação'
    },
    'ACOES_VOLTAR': {
      'BRINDES': 'Voltou para passo Brindes em Renovação',
      'ENTREGA': 'Voltou para passo Entrega em Renovação',
      'PAGAMENTO': 'Voltou para passo Pagamento em Renovação'
    },
    'FLUXO': 'RENOVACAO'
  },
  'CANCELAMENTO': {
    'ACOES': {
      'CONFIRMAR_CANCELAMENTO': 'Confirmou cancelamento',
      'INIT': 'Entrou em Cancelamento',
      'PERMANECER': 'Desistiu de cancelar',
      'PERMANECER_TELA_MULTA': 'Desistiu de Cancelar na Tela de Multa',
      'SEGUIR_CANCELAMENTO_FORMULARIO':
               'Seguiu com cancelamento para o formulário de cancelamento',
      'SEGUIR_CANCELAMENTO_SUSPENSAO':
               'Seguiu com cancelamento para suspensão',
      'SEGUIR_CANCELAMENTO_SUSPENSAO_TELA_MULTA':
               'Seguiu com cancelamento para suspensão na tela de multa',
      'SEGUIR_CANCELAMENTO_SUSPENSAO_FORMULARIO':
               'Seguiu com o cancelamento para o formulário de suspensão',
      'SUSPENDER': 'Confirmou suspensão'
    },
    'ACOES_VOLTAR': {
      'VOLTOU_SUSPENSAO': 'Clicou em voltar na etapa de suspensão.',
      'VOLTOU_CANCELAMENTO':
               'Clicou em voltar na etapa de confirmar cancelamento'
    },
    'FLUXO': 'CANCELAMENTO'
  },
  'REATIVACAO': {
    'ACOES': {
      'BRINDES': 'Passo Brindes em Reativação',
      'CONCLUSAO': 'Concluiu Reativação',
      'ENTREGA': 'Passo entrega em Reativação',
      'INIT': 'Entrou em Reativação',
      'PAGAMENTO': 'Passo pagamento em Reativação',
      'PLANO': 'Passo Escolha de Plano em Reativação'
    },
    'ACOES_VOLTAR': {
      'PAGAMENTO': 'Voltou para passo Pagamento em Reativação',
      'PLANO': 'Voltou para passo Escolha de plano em Reativação',
      'ENTREGA': 'Voltou para passo Entrega em Reativação',
      'BRINDES': 'Voltou para passo Brindes em Reativação'
    },
    'FLUXO': 'REATIVACAO'
  },
  'MGM': {
    'ACOES': {
      'FACEBOOK': 'Escolheu indicar amigo via Facebook',
      'FECHOU_MODAL': 'Fechou a modal de MGM',
      'EMAIL': 'Escolheu indicar amigo via e-mail',
      'ENVIOU_EMAIL': 'Enviou e-mail para amigo',
      'WHATSAPP': 'Escolheu indicar amigo via WhatsApp'
    },
    'FLUXO': 'MGM'
  },
  'VIDEO': {
    'ACOES': {
      'ENTROU_CONEXAO': 'Clickou no link da Conexão TAG',
      'INICIOU_VIDEO': 'Deu início no vídeo',
      'TERMINOU': 'Viu o vídeo até o fim'
    },
    'FLUXO': 'VIDEO'
  },
  'ONBOARDING': {
    'ACOES': {
      'TERMINOU': 'Viu o vídeo de onboarding até o fim'
    },
    'FLUXO': 'ONBOARDING'
  },
  'BANNER_APP': {
    'ACOES': {
      'ABRIU': 'Clicou no Banner do APP'
    },
    'FLUXO': 'BANNER_APP'
  },
  'CAROUSEL': {
    'ACOES': {
      'CLICOU_PROXIMO_INEDITOS':
               'Clicou na seta de próximo carousel (inéditos)',
      'CLICOU_PROXIMO_Curadoria':
               'Clicou na seta de próximo carousel (curadoria)'
    },
    'FLUXO': 'CAROUSEL'
  }
}

export const EVENTOS_PIXEL = {
  'SEGUNDA_ASSINATURA': 'Assinou combo',
  'RENOVACAO': 'Renovou assinatura',
  'REATIVACAO': 'Reativou assianatura',
  'UPGRADE': 'Upgrade'
}

export const ORIGENS_COBRANCA = {
  'REATIVACAO': {
    'artigo': 'a',
    'texto': 'reativação de assinatura',
  },
  'RENOVACAO_PLANO_MANUAL': {
    'artigo': 'a',
    'texto': 'renovação de plano',
  },
  'UPGRADE_PLANO': {
    'artigo': 'o',
    'texto': 'upgrade de plano',
  },
}

export const MODAL_ERRO_ATUALIZACAO_ASSINATURA = {
  'TITULO': 'Erro ao atualizar assinatura',
  'DESCRICAO': 'Ocorreu um erro ao tentar atualizar sua assinatura. Por favor, tente novamente mais tarde.',
  'MENSAGEM': 'Se o problema persistir, entre em contato com o suporte.'
}

export const ROUTE_BASEPATH = URLS_APP.BASE_PATH || URLS.HOME

export const OPCOES_MENU_VISUALIZACAO = {
  'ASSINATURA_PRESENTE': 'Assinatura presente',
  'BLOG': 'Blog',
  'BOOKSTER': 'Bookster',
  'CURADORIA': MODALIDADE_CURADORIA.visualizacao,
  'DUVIDAS': 'Dúvidas',
  'HOME': 'Home',
  'INEDITOS': MODALIDADE_INEDITOS.visualizacao,
  'LOJA': 'Livraria',
  'MEUS_KITS': 'Meus kits',
  'TRILHAS': 'Trilhas literárias',
  'MGM': 'Indique um amigo',
}

export const AVISO_COBRANCA_BOLETO_PENDENTE_TITULO = 'Atenção!'
export const AVISO_COBRANCA_BOLETO_PENDENTE_MENSAGEM = 'Você possui um boleto em espera. Confira o link do boleto no seu e-mail ou entre em contato.'

export const AVISO_COBRANCA_PIX_PENDENTE_MENSAGEM = 'Existe um PIX referente à sua segunda assinatura aguardando pagamento.'

export const STATUS_ASSINATURA = {
  'ATIVO': 'ativo',
  'SUSPENSO': 'suspenso',
  'CANCELADO': 'cancelado',
  'SOLICITOU_CANCELAMENTO': 'solicitou cancelamento',
}

export const MSG_STATUS_ASSINATURA = {
  'ATIVO': 'Assinatura ativa',
  'SUSPENSO': 'Assinatura suspensa',
  'CANCELADO': 'Assinatura cancelada',
  'SOLICITOU_CANCELAMENTO': 'Cancelamento agendado',
}


export const STATUS_VENDA = {
  'aguardandoResgate': 'AGUARDANDO_RESGATE',
  'bonificacao': 'BONIFICACAO',
  'cancelado': 'CANCELADO',
  'cobrado': 'COBRADO',
  'dispensado': 'DISPENSADO',
  'espera': 'ESPERA',
  'estornado': 'ESTORNADO',
  'estornoParcial': 'ESTORNO_PARCIAL',
  'falha': 'FALHA',
  'aguardandoEscolhaClube': 'AGUARDANDO_ESCOLHA_CLUBE',
}

export const STATUS_ENVIO = {
  'arquivoRecebido': 'ARQUIVO_RECEBIDO',
  'cancelado': 'CANCELADO',
  'cotado': 'COTADO',
  'cotando': 'COTANDO',
  'despachado': 'DESPACHADO',
  'devolvido': 'DEVOLVIDO',
  'emDevolucao': 'EM_DEVOLUCAO',
  'emitindoNf': 'EMITINDO_NF',
  'emProcessamento': 'EM_PROCESSAMENTO',
  'emTransito': 'EM_TRANSITO',
  'entregue': 'ENTREGUE',
  'erroAoGerarNf': 'ERRO_AO_GERAR_NF',
  'erroAtualizarDadosNf': 'ERRO_ATUALIZAR_DADOS_NF',
  'erroEmissaoNfEntrega': 'ERRO_EMISSAO_NF_ENTREGA',
  'erroEtiqueta': 'ERRO_ETIQUETA',
  'erroNaCotacao': 'ERRO_NA_COTACAO',
  'erroSolicitacaoPedidoIntelipost': 'ERRO_SOLICITACAO_PEDIDO_INTELIPOST',
  'espera': 'ESPERA',
  'extraviado': 'EXTRAVIADO',
  'falhaEntrega': 'FALHA_ENTREGA',
  'falhaNoPedido': 'FALHA_NO_PEDIDO',
  'faturado': 'FATURADO',
  'logisticaReversaCedepp': 'LOGISTICA_REVERSA_CEDEPP',
  'logisticaReversaCorreios': 'LOGISTICA_REVERSA_CORREIOS',
  'motivoFalha': 'MOTIVO_FALHA',
  'processandoPedido': 'PROCESSANDO_PEDIDO',
  'rastreamentoCancelado': 'RASTREAMENTO_CANCELADO',
  'rastreamentoExpirado': 'RASTREAMENTO_EXPIRADO',
  'realocada': 'REALOCADA',
  'recotando': 'RECOTANDO',
  'saiuPraEntrega': 'SAIU_PRA_ENTREGA',
}

export const BREAKPOINT = {
  'sm': '640px',
  'md': '768px',
  'lg': '1024px',
  'xl': '1280px'
}

export const DESCONTO_UPGRADE = {
  [ PLANO_ANUAL.slug ]: {
    [ MODALIDADE_CURADORIA.slug ]: {
      [ PLANO_MENSAL.slug ]: '25%',
      [ PLANO_TRIMESTRAL.slug ]: '6%',
    },
    [ MODALIDADE_INEDITOS.slug ]: {
      [ PLANO_MENSAL.slug ]: '25%',
      [ PLANO_TRIMESTRAL.slug ]: '8%',
    },
  },
  [ PLANO_TRIMESTRAL.slug ]: {
    [ MODALIDADE_CURADORIA.slug ]: {
      [ PLANO_MENSAL.slug ]: '7%',
    },
    [ MODALIDADE_INEDITOS.slug ]: {
      [ PLANO_MENSAL.slug ]: '5%',
    },
  }
}
